import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SelectDateService {
  private selectedStartDateSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public curentSelectedStartDate = this.selectedStartDateSource.asObservable();

  private selectedEndDateSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public curentSelectedEndtDate = this.selectedEndDateSource.asObservable();

  constructor() { }

  public changeSelectedStartDate(date: string) {
    this.selectedStartDateSource.next(date);
  }

  public get selectedStartDate() {
    return this.selectedStartDateSource.value;
  }

  public changeSelectedEndtDate(date: string) {
    this.selectedEndDateSource.next(date);
  }

  public get selectedEndtDate() {
    return this.selectedEndDateSource.value;
  }
}
